webpackJsonp([188143796425938],{

/***/ 1822:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"LabResultEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"LabResult","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-lab-result-edge-aa3c767a9373aa883c5b.js